/* eslint-disable max-lines */
import { STEPS_WOOFZ22_V3 } from 'nove8/cohorts/woofz22_v3/constants/steps'
import { STEPS_WOOFZ22_V4 } from 'nove8/cohorts/woofz22_v4/constants/steps'
import { STEPS_WOOFZ22_V4_WT } from 'nove8/cohorts/woofz22_v4_wt/constants/steps'
import { STEPS_WOOFZ22_V4_BG } from 'nove8/cohorts/woofz22_v4_bg/constants/steps'
import { STEPS_WOOFZ22_V4L } from 'nove8/cohorts/woofz22_v4l/constants/steps'
import { STEPS_WOOFZ22_V4T } from 'nove8/cohorts/woofz22_v4t/constants/steps'
import { STEPS_WOOFZ_COACHING } from 'nove8/cohorts/woofz_coaching/constants/steps'
import { STEPS_WOOFZ_EASTER_65 } from 'nove8/cohorts/woofz_easter/woofz_easter_65/constants/steps'
import { STEPS_WOOFZ_EASTER_70 } from 'nove8/cohorts/woofz_easter/woofz_easter_70/constants/steps'
import { STEPS_WOOFZ_EASTER_75 } from 'nove8/cohorts/woofz_easter/woofz_easter_75/constants/steps'
import { STEPS_WOOFZ_EASTER_80 } from 'nove8/cohorts/woofz_easter/woofz_easter_80/constants/steps'
import { STEPS_WOOFZ_ESA } from 'nove8/cohorts/woofz_esa/constants/steps'
import { STEPS_WOOFZ_HLWN_65 } from 'nove8/cohorts/woofz_hlwn/woofz_hlwn_65/constants/steps'
import { STEPS_WOOFZ_HLWN_70 } from 'nove8/cohorts/woofz_hlwn/woofz_hlwn_70/constants/steps'
import { STEPS_WOOFZ_HLWN_75 } from 'nove8/cohorts/woofz_hlwn/woofz_hlwn_75/constants/steps'
import { STEPS_WOOFZ_HLWN_80 } from 'nove8/cohorts/woofz_hlwn/woofz_hlwn_80/constants/steps'
import { STEPS_WOOFZ_INVX } from 'nove8/cohorts/woofz_invx/constants/steps'
import { STEPS_WOOFZ_K9 } from 'nove8/cohorts/woofz_k9/constants/steps'
import { STEPS_WOOFZ_K9_BL } from 'nove8/cohorts/woofz_k9_bl/constants/steps'
import { STEPS_WOOFZ_K9_BL_BG } from 'nove8/cohorts/woofz_k9_bl_bg/constants/steps'
import { STEPS_WOOFZ_K9_DRSL } from 'nove8/cohorts/woofz_k9_drsl/constants/steps'
import { STEPS_WOOFZ_LOVE } from 'nove8/cohorts/woofz_love/constants/steps'
import { STEPS_WOOFZ_LOVE_BL } from 'nove8/cohorts/woofz_love_bl/constants/steps'
import { STEPS_WOOFZ_NDD_65 } from 'nove8/cohorts/woofz_ndd/woofz_ndd_65/constants/steps'
import { STEPS_WOOFZ_NDD_70 } from 'nove8/cohorts/woofz_ndd/woofz_ndd_70/constants/steps'
import { STEPS_WOOFZ_NDD_75 } from 'nove8/cohorts/woofz_ndd/woofz_ndd_75/constants/steps'
import { STEPS_WOOFZ_NDD_80 } from 'nove8/cohorts/woofz_ndd/woofz_ndd_80/constants/steps'
import { STEPS_WOOFZ_NDD } from 'nove8/cohorts/woofz_ndd/woofz_ndd_cohort/constants/steps'
import { STEPS_WOOFZ_NPDAY_65 } from 'nove8/cohorts/woofz_npday/woofz_npday_65/constants/steps'
import { STEPS_WOOFZ_NPDAY_70 } from 'nove8/cohorts/woofz_npday/woofz_npday_70/constants/steps'
import { STEPS_WOOFZ_NPDAY_75 } from 'nove8/cohorts/woofz_npday/woofz_npday_75/constants/steps'
import { STEPS_WOOFZ_NPDAY_80 } from 'nove8/cohorts/woofz_npday/woofz_npday_80/constants/steps'
import { STEPS_WOOFZ_NRDAY_65 } from 'nove8/cohorts/woofz_nrday/woofz_nrday_65/constants/steps'
import { STEPS_WOOFZ_NRDAY_70 } from 'nove8/cohorts/woofz_nrday/woofz_nrday_70/constants/steps'
import { STEPS_WOOFZ_NRDAY_75 } from 'nove8/cohorts/woofz_nrday/woofz_nrday_75/constants/steps'
import { STEPS_WOOFZ_NRDAY_80 } from 'nove8/cohorts/woofz_nrday/woofz_nrday_80/constants/steps'
import { STEPS_WOOFZ_OFFER1_65 } from 'nove8/cohorts/woofz_offer/woofz_offer1_65/constants/steps'
import { STEPS_WOOFZ_OFFER1_70 } from 'nove8/cohorts/woofz_offer/woofz_offer1_70/constants/steps'
import { STEPS_WOOFZ_OFFER1_75 } from 'nove8/cohorts/woofz_offer/woofz_offer1_75/constants/steps'
import { STEPS_WOOFZ_OFFER1_80 } from 'nove8/cohorts/woofz_offer/woofz_offer1_80/constants/steps'
import { STEPS_WOOFZ_OFFER2_70 } from 'nove8/cohorts/woofz_offer/woofz_offer2_70/constants/steps'
import { STEPS_WOOFZ_OFFER2_75 } from 'nove8/cohorts/woofz_offer/woofz_offer2_75/constants/steps'
import { STEPS_WOOFZ_PAW_NUP } from 'nove8/cohorts/woofz_paw_nup/constants/steps'
import { STEPS_WOOFZ_PN } from 'nove8/cohorts/woofz_pn/constants/steps'
import { STEPS_WOOFZ_PPDAY_65 } from 'nove8/cohorts/woofz_ppday/woofz_ppday_65/constants/steps'
import { STEPS_WOOFZ_PPDAY_70 } from 'nove8/cohorts/woofz_ppday/woofz_ppday_70/constants/steps'
import { STEPS_WOOFZ_PPDAY_75 } from 'nove8/cohorts/woofz_ppday/woofz_ppday_75/constants/steps'
import { STEPS_WOOFZ_PPDAY_80 } from 'nove8/cohorts/woofz_ppday/woofz_ppday_80/constants/steps'
import { STEPS_WOOFZ_PPP } from 'nove8/cohorts/woofz_ppp/constants/steps'
import { STEPS_WOOFZ_PPP_BL } from 'nove8/cohorts/woofz_ppp_bl/constants/steps'
import { STEPS_WOOFZ_PPP_WOOFY } from 'nove8/cohorts/woofz_ppp_woofy/constants/steps'
import { STEPS_WOOFZ_PT1 } from 'nove8/cohorts/woofz_pt1/constants/steps'
import { STEPS_WOOFZ_PT1_BG } from 'nove8/cohorts/woofz_pt1_bg/constants/steps'
import { STEPS_WOOFZ_PUP } from 'nove8/cohorts/woofz_pup/constants/steps'
import { STEPS_WOOFZ_PUP_BL } from 'nove8/cohorts/woofz_pup_bl/constants/steps'
import { STEPS_WOOFZ_PUP_DRSL } from 'nove8/cohorts/woofz_pup_drsl/constants/steps'
import { STEPS_WOOFZ_PUP_WT } from 'nove8/cohorts/woofz_pup_wt/constants/steps'
import { STEPS_WOOFZ_RFND3 } from 'nove8/cohorts/woofz_rfnd3/constants/steps'
import { STEPS_WOOFZ_RFND3_ND } from 'nove8/cohorts/woofz_rfnd3_nd/constants/steps'
import { STEPS_WOOFZ_RT } from 'nove8/cohorts/woofz_rt/constants/steps'
import { STEPS_WOOFZ_S1_6_12 } from 'nove8/cohorts/woofz_s/woofz_s1_6_12/constants/steps'
import { STEPS_WOOFZ_S2_6_12 } from 'nove8/cohorts/woofz_s/woofz_s2_6_12/constants/steps'
import { STEPS_WOOFZ_S3_6_12 } from 'nove8/cohorts/woofz_s/woofz_s3_6_12/constants/steps'
import { STEPS_WOOFZ_SMD } from 'nove8/cohorts/woofz_smd/constants/steps'
import { STEPS_WOOFZ_SMD_BL } from 'nove8/cohorts/woofz_smd_bl/constants/steps'
import { STEPS_WOOFZ_SUB_CNLD_70 } from 'nove8/cohorts/woofz_sub_cnld_70/constants/steps'
import { STEPS_WOOFZ_VC6 } from 'nove8/cohorts/woofz_vc6/constants/steps'
import { STEPS_WOOFZ_VDAY_65 } from 'nove8/cohorts/woofz_vday/woofz_vday_65/constants/steps'
import { STEPS_WOOFZ_VDAY_70 } from 'nove8/cohorts/woofz_vday/woofz_vday_70/constants/steps'
import { STEPS_WOOFZ_VDAY_75 } from 'nove8/cohorts/woofz_vday/woofz_vday_75/constants/steps'
import { STEPS_WOOFZ_VDAY_80 } from 'nove8/cohorts/woofz_vday/woofz_vday_80/constants/steps'
import { STEPS_WOOFZ_VGS } from 'nove8/cohorts/woofz_vgs/constants/steps'
import { STEPS_WOOFZ_WA1 } from 'nove8/cohorts/woofz_wa1/constants/steps'
import { STEPS_WOOFZ_WS2 } from 'nove8/cohorts/woofz_ws2/constants/steps'
import { STEPS_WOOFZ_XMAS_65 } from 'nove8/cohorts/woofz_xmas/woofz_xmas_65/constants/steps'
import { STEPS_WOOFZ_XMAS_70 } from 'nove8/cohorts/woofz_xmas/woofz_xmas_70/constants/steps'
import { STEPS_WOOFZ_XMAS_80 } from 'nove8/cohorts/woofz_xmas/woofz_xmas_80/constants/steps'
import React, { lazy, LazyExoticComponent, PropsWithChildren } from 'react'
import { STEPS_WOOFZ22_V9 } from '../cohorts/woofz22_v9/constants/steps'
import { Cohort } from './root-constants'

export const DYNAMIC_COMPONENTS_MAP: Record<
  Cohort,
  {
    RoutesList: LazyExoticComponent<React.FC>
    Header: LazyExoticComponent<React.FC>
    BgPreloadingMediaProvider: LazyExoticComponent<React.FC<PropsWithChildren>>
  }
> = {
  [Cohort.WOOFZ22_V9]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ22_V9,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz22_v9/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz22_v9/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderWoofz22V9,
      })),
    ),
  },
  [Cohort.WOOFZ_ESA]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_ESA,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_esa/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_esa/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzEsa,
      })),
    ),
  },
  [Cohort.WOOFZ_PN]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_PN,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_pn/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_pn/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzPn,
      })),
    ),
  },
  [Cohort.WOOFZ22_V4L]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ22_V4L,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz22_v4l/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz22_v4l/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderWoofz22V4L,
      })),
    ),
  },
  [Cohort.WOOFZ_WS2]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_WS2,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_ws2/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_ws2/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzWs2,
      })),
    ),
  },
  [Cohort.WOOFZ_RFND3_ND]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_RFND3_ND,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_rfnd3_nd/components/header/Header').then(
        (m) => ({
          default: m.Header,
        }),
      ),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_rfnd3_nd/BgPreloadingMediaProvider').then(
        (m) => ({
          default: m.BgPreloadingMediaProviderWoofzRfnd3Nd,
        }),
      ),
    ),
  },
  [Cohort.WOOFZ22_V3]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ22_V3,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz22_v3/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz22_v3/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderWoofz22V3,
      })),
    ),
  },
  [Cohort.WOOFZ_RFND3]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_RFND3,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_rfnd3/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_rfnd3/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzRfnd3,
      })),
    ),
  },
  [Cohort.WOOFZ_VGS]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_VGS,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_vgs/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_vgs/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzVgs,
      })),
    ),
  },
  [Cohort.WOOFZ_PPP]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_PPP,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_ppp/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_ppp/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzPpp,
      })),
    ),
  },
  [Cohort.WOOFZ_PPP_BL]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_PPP_BL,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_ppp_bl/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_ppp_bl/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzPppBl,
      })),
    ),
  },
  [Cohort.WOOFZ_PPP_WOOFY]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_PPP_WOOFY,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_ppp_woofy/components/header/Header').then(
        (m) => ({
          default: m.Header,
        }),
      ),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_ppp_woofy/BgPreloadingMediaProvider').then(
        (m) => ({
          default: m.BgPreloadingMediaProviderWoofzPppWoofy,
        }),
      ),
    ),
  },
  [Cohort.WOOFZ_LOVE]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_LOVE,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_love/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_love/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzLove,
      })),
    ),
  },
  [Cohort.WOOFZ_LOVE_BL]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_LOVE_BL,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_love_bl/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_love_bl/BgPreloadingMediaProvider').then(
        (m) => ({
          default: m.BgPreloadingMediaProviderWoofzLoveBl,
        }),
      ),
    ),
  },
  [Cohort.WOOFZ_PUP]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_PUP,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_pup/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_pup/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzPup,
      })),
    ),
  },
  [Cohort.WOOFZ_PUP_BL]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_PUP_BL,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_pup_bl/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_pup_bl/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzPupBl,
      })),
    ),
  },
  [Cohort.WOOFZ22_V4]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ22_V4,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz22_v4/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz22_v4/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderWoofz22V4,
      })),
    ),
  },
  [Cohort.WOOFZ_RT]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_RT,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_rt/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_rt/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzRt,
      })),
    ),
  },
  [Cohort.WOOFZ_PT1]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_PT1,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_pt1/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_pt1/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzPt1,
      })),
    ),
  },
  [Cohort.WOOFZ_WA1]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_WA1,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_wa1/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_wa1/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzWa1,
      })),
    ),
  },
  [Cohort.WOOFZ_EASTER_65]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_EASTER_65,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_easter/woofz_easter_65/components/header/HeaderUpsell'
      ).then((m) => ({
        default: m.HeaderUpsell,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_easter/woofz_easter_65/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzEaster65,
      })),
    ),
  },
  [Cohort.WOOFZ_EASTER_70]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_EASTER_70,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_easter/woofz_easter_70/components/header/HeaderUpsell'
      ).then((m) => ({
        default: m.HeaderUpsell,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_easter/woofz_easter_70/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzEaster70,
      })),
    ),
  },
  [Cohort.WOOFZ_EASTER_75]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_EASTER_75,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_easter/woofz_easter_75/components/header/HeaderUpsell'
      ).then((m) => ({
        default: m.HeaderUpsell,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_easter/woofz_easter_75/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzEaster75,
      })),
    ),
  },
  [Cohort.WOOFZ_EASTER_80]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_EASTER_80,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_easter/woofz_easter_80/components/header/HeaderUpsell'
      ).then((m) => ({
        default: m.HeaderUpsell,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_easter/woofz_easter_80/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzEaster80,
      })),
    ),
  },
  [Cohort.WOOFZ_NPDAY_65]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_NPDAY_65,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_npday/woofz_npday_65/components/header/HeaderUpsell'
      ).then((m) => ({
        default: m.HeaderUpsell,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_npday/woofz_npday_65/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzNpday65,
      })),
    ),
  },
  [Cohort.WOOFZ_NPDAY_70]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_NPDAY_70,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_npday/woofz_npday_70/components/header/HeaderUpsell'
      ).then((m) => ({
        default: m.HeaderUpsell,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_npday/woofz_npday_70/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzNpday70,
      })),
    ),
  },
  [Cohort.WOOFZ_NPDAY_75]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_NPDAY_75,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_npday/woofz_npday_75/components/header/HeaderUpsell'
      ).then((m) => ({
        default: m.HeaderUpsell,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_npday/woofz_npday_75/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzNpday75,
      })),
    ),
  },
  [Cohort.WOOFZ_NPDAY_80]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_NPDAY_80,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_npday/woofz_npday_80/components/header/HeaderUpsell'
      ).then((m) => ({
        default: m.HeaderUpsell,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_npday/woofz_npday_80/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzNpday80,
      })),
    ),
  },
  [Cohort.WOOFZ_PPDAY_65]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_PPDAY_65,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_ppday/woofz_ppday_65/components/header/HeaderUpsell'
      ).then((m) => ({
        default: m.HeaderUpsell,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_ppday/woofz_ppday_65/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzPpday65,
      })),
    ),
  },
  [Cohort.WOOFZ_PPDAY_70]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_PPDAY_70,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_ppday/woofz_ppday_70/components/header/HeaderUpsell'
      ).then((m) => ({
        default: m.HeaderUpsell,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_ppday/woofz_ppday_70/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzPpday70,
      })),
    ),
  },
  [Cohort.WOOFZ_PPDAY_75]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_PPDAY_75,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_ppday/woofz_ppday_75/components/header/HeaderUpsell'
      ).then((m) => ({
        default: m.HeaderUpsell,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_ppday/woofz_ppday_75/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzPpday75,
      })),
    ),
  },
  [Cohort.WOOFZ_PPDAY_80]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_PPDAY_80,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_ppday/woofz_ppday_80/components/header/HeaderUpsell'
      ).then((m) => ({
        default: m.HeaderUpsell,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_ppday/woofz_ppday_80/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzPpday80,
      })),
    ),
  },
  [Cohort.WOOFZ_NRDAY_65]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_NRDAY_65,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_nrday/woofz_nrday_65/components/header/HeaderUpsell'
      ).then((m) => ({
        default: m.HeaderUpsell,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_nrday/woofz_nrday_65/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzNrday65,
      })),
    ),
  },
  [Cohort.WOOFZ_NRDAY_70]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_NRDAY_70,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_nrday/woofz_nrday_70/components/header/HeaderUpsell'
      ).then((m) => ({
        default: m.HeaderUpsell,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_nrday/woofz_nrday_70/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzNrday70,
      })),
    ),
  },
  [Cohort.WOOFZ_NRDAY_75]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_NRDAY_75,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_nrday/woofz_nrday_75/components/header/HeaderUpsell'
      ).then((m) => ({
        default: m.HeaderUpsell,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_nrday/woofz_nrday_75/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzNrday75,
      })),
    ),
  },
  [Cohort.WOOFZ_NRDAY_80]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_NRDAY_80,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_nrday/woofz_nrday_80/components/header/HeaderUpsell'
      ).then((m) => ({
        default: m.HeaderUpsell,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_nrday/woofz_nrday_80/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzNrday80,
      })),
    ),
  },
  [Cohort.WOOFZ_OFFER1_65]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_OFFER1_65,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_offer/woofz_offer1_65/components/header/HeaderUpsell'
      ).then((m) => ({
        default: m.HeaderUpsell,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_offer/woofz_offer1_65/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzOffer165,
      })),
    ),
  },
  [Cohort.WOOFZ_OFFER1_70]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_OFFER1_70,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_offer/woofz_offer1_70/components/header/HeaderUpsell'
      ).then((m) => ({
        default: m.HeaderUpsell,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_offer/woofz_offer1_70/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzOffer170,
      })),
    ),
  },
  [Cohort.WOOFZ_OFFER1_75]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_OFFER1_75,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_offer/woofz_offer1_75/components/header/HeaderUpsell'
      ).then((m) => ({
        default: m.HeaderUpsell,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_offer/woofz_offer1_75/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzOffer175,
      })),
    ),
  },
  [Cohort.WOOFZ_OFFER1_80]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_OFFER1_80,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_offer/woofz_offer1_80/components/header/HeaderUpsell'
      ).then((m) => ({
        default: m.HeaderUpsell,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_offer/woofz_offer1_80/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzOffer180,
      })),
    ),
  },
  [Cohort.WOOFZ_OFFER2_70]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_OFFER2_70,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_offer/woofz_offer2_70/components/header/HeaderUpsell'
      ).then((m) => ({
        default: m.HeaderUpsell,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_offer/woofz_offer2_70/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzOffer270,
      })),
    ),
  },
  [Cohort.WOOFZ_OFFER2_75]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_OFFER2_75,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_offer/woofz_offer2_75/components/header/HeaderUpsell'
      ).then((m) => ({
        default: m.HeaderUpsell,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_offer/woofz_offer2_75/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzOffer275,
      })),
    ),
  },
  [Cohort.WOOFZ_VC6]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_VC6,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_vc6/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_vc6/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzVc6,
      })),
    ),
  },
  [Cohort.WOOFZ_INVX]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_INVX,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_invx/components/header/HeaderPlaceholder').then(
        (m) => ({
          default: m.HeaderPlaceholder,
        }),
      ),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_invx/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzInvx,
      })),
    ),
  },
  [Cohort.WOOFZ_S1_6_12]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_S1_6_12,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_s/woofz_s1_6_12/components/header/Header').then(
        (m) => ({
          default: m.Header,
        }),
      ),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_s/woofz_s1_6_12/BgPreloadingMediaProvider').then(
        (m) => ({
          default: m.BgPreloadingMediaProvider,
        }),
      ),
    ),
  },
  [Cohort.WOOFZ_S2_6_12]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_S2_6_12,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_s/woofz_s2_6_12/components/header/Header').then(
        (m) => ({
          default: m.Header,
        }),
      ),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_s/woofz_s2_6_12/BgPreloadingMediaProvider').then(
        (m) => ({
          default: m.BgPreloadingMediaProvider,
        }),
      ),
    ),
  },
  [Cohort.WOOFZ_S3_6_12]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_S3_6_12,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_s/woofz_s3_6_12/components/header/Header').then(
        (m) => ({
          default: m.Header,
        }),
      ),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_s/woofz_s3_6_12/BgPreloadingMediaProvider').then(
        (m) => ({
          default: m.BgPreloadingMediaProvider,
        }),
      ),
    ),
  },
  [Cohort.WOOFZ_K9]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_K9,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_k9/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_k9/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzK9,
      })),
    ),
  },
  [Cohort.WOOFZ_K9_BL]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_K9_BL,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_k9_bl/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_k9_bl/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzK9Bl,
      })),
    ),
  },
  [Cohort.WOOFZ_K9_BL_1]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_K9_BL,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_k9_bl/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_k9_bl/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzK9Bl,
      })),
    ),
  },
  [Cohort.WOOFZ_K9_BL_2]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_K9_BL,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_k9_bl/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_k9_bl/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzK9Bl,
      })),
    ),
  },
  [Cohort.WOOFZ_K9_BL_3]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_K9_BL,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_k9_bl/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_k9_bl/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzK9Bl,
      })),
    ),
  },
  [Cohort.WOOFZ_K9_DRSL]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_K9_DRSL,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_k9_drsl/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_k9_drsl/BgPreloadingMediaProvider').then(
        (m) => ({
          default: m.BgPreloadingMediaProviderWoofzK9Drsl,
        }),
      ),
    ),
  },
  [Cohort.WOOFZ_PUP_WT]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_PUP_WT,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_pup_wt/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_pup_wt/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzPupWt,
      })),
    ),
  },
  [Cohort.WOOFZ_PUP_DRSL]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_PUP_DRSL,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_pup_drsl/components/header/Header').then(
        (m) => ({
          default: m.Header,
        }),
      ),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_pup_drsl/BgPreloadingMediaProvider').then(
        (m) => ({
          default: m.BgPreloadingMediaProviderWoofzPupDrsl,
        }),
      ),
    ),
  },
  [Cohort.WOOFZ_WOOFY1]: {
    RoutesList: lazy(() =>
      import('../cohorts/woofz_woofy1/WoofzWoofyRoutesList').then((m) => ({
        default: m.WoofzWoofyRoutesList,
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_woofy1/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_woofy1/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzWoofy,
      })),
    ),
  },
  [Cohort.WOOFZ_COACHING]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_COACHING,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_coaching/components/header/Header').then(
        (m) => ({
          default: m.Header,
        }),
      ),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_coaching/BgPreloadingMediaProvider').then(
        (m) => ({
          default: m.BgPreloadingMediaProviderWoofzCoaching,
        }),
      ),
    ),
  },
  [Cohort.WOOFZ_VDAY_65]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_VDAY_65,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_vday/woofz_vday_65/components/header/Header'
      ).then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_vday/woofz_vday_65/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzVday65,
      })),
    ),
  },
  [Cohort.WOOFZ_VDAY_70]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_VDAY_70,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_vday/woofz_vday_70/components/header/Header'
      ).then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_vday/woofz_vday_70/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzVday70,
      })),
    ),
  },
  [Cohort.WOOFZ_VDAY_75]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_VDAY_75,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_vday/woofz_vday_75/components/header/Header'
      ).then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_vday/woofz_vday_75/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzVday75,
      })),
    ),
  },
  [Cohort.WOOFZ_VDAY_80]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_VDAY_80,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_vday/woofz_vday_80/components/header/Header'
      ).then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_vday/woofz_vday_80/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzVday80,
      })),
    ),
  },
  [Cohort.WOOFZ_NDD]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_NDD,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_ndd/woofz_ndd_cohort/components/header/Header'
      ).then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_ndd/woofz_ndd_cohort/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzNdd,
      })),
    ),
  },
  [Cohort.WOOFZ_NDD_65]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_NDD_65,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_ndd/woofz_ndd_65/components/header/Header').then(
        (m) => ({
          default: m.Header,
        }),
      ),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_ndd/woofz_ndd_65/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzNdd65,
      })),
    ),
  },
  [Cohort.WOOFZ_NDD_70]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_NDD_70,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_ndd/woofz_ndd_70/components/header/Header').then(
        (m) => ({
          default: m.Header,
        }),
      ),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_ndd/woofz_ndd_70/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzNdd70,
      })),
    ),
  },
  [Cohort.WOOFZ_NDD_75]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_NDD_75,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_ndd/woofz_ndd_75/components/header/Header').then(
        (m) => ({
          default: m.Header,
        }),
      ),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_ndd/woofz_ndd_75/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzNdd75,
      })),
    ),
  },
  [Cohort.WOOFZ_NDD_80]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_NDD_80,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_ndd/woofz_ndd_80/components/header/Header').then(
        (m) => ({
          default: m.Header,
        }),
      ),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_ndd/woofz_ndd_80/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzNdd80,
      })),
    ),
  },
  [Cohort.WOOFZ_SUB_CNLD_70]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_SUB_CNLD_70,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_sub_cnld_70/components/header/Header').then(
        (m) => ({
          default: m.Header,
        }),
      ),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_sub_cnld_70/BgPreloadingMediaProvider').then(
        (m) => ({
          default: m.BgPreloadingMediaProviderWoofzSubCnld70,
        }),
      ),
    ),
  },
  [Cohort.WOOFZ22_V4T]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ22_V4T,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz22_v4t/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz22_v4t/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderWoofz22V4t,
      })),
    ),
  },
  [Cohort.WOOFZ_HLWN_65]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_HLWN_65,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_hlwn/woofz_hlwn_65/components/header/Header'
      ).then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_hlwn/woofz_hlwn_65/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzHlwn65,
      })),
    ),
  },
  [Cohort.WOOFZ_HLWN_70]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_HLWN_70,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_hlwn/woofz_hlwn_70/components/header/Header'
      ).then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_hlwn/woofz_hlwn_70/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzHlwn70,
      })),
    ),
  },
  [Cohort.WOOFZ_HLWN_75]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_HLWN_75,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_hlwn/woofz_hlwn_75/components/header/Header'
      ).then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_hlwn/woofz_hlwn_75/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzHlwn75,
      })),
    ),
  },
  [Cohort.WOOFZ_HLWN_80]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_HLWN_80,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_hlwn/woofz_hlwn_80/components/header/Header'
      ).then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_hlwn/woofz_hlwn_80/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzHlwn80,
      })),
    ),
  },
  [Cohort.WOOFZ_XMAS_65]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_XMAS_65,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_xmas/woofz_xmas_65/components/header/HeaderUpsell'
      ).then((m) => ({
        default: m.HeaderUpsell,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_xmas/woofz_xmas_65/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzXmas65,
      })),
    ),
  },
  [Cohort.WOOFZ_XMAS_70]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_XMAS_70,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_xmas/woofz_xmas_70/components/header/HeaderUpsell'
      ).then((m) => ({
        default: m.HeaderUpsell,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_xmas/woofz_xmas_70/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzXmas70,
      })),
    ),
  },
  [Cohort.WOOFZ_XMAS_80]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_XMAS_80,
          }),
      })),
    ),
    Header: lazy(() =>
      import(
        '../cohorts/woofz_xmas/woofz_xmas_80/components/header/HeaderUpsell'
      ).then((m) => ({
        default: m.HeaderUpsell,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import(
        '../cohorts/woofz_xmas/woofz_xmas_80/BgPreloadingMediaProvider'
      ).then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzXmas80,
      })),
    ),
  },
  [Cohort.WOOFZ_PAW_NUP]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_PAW_NUP,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_paw_nup/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_paw_nup/BgPreloadingMediaProvider').then(
        (m) => ({
          default: m.BgPreloadingMediaProviderWoofzPawNup,
        }),
      ),
    ),
  },
  [Cohort.WOOFZ_SMD]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_SMD,
          }),
      })),
    ),
    Header: lazy(() =>
      import('nove8/cohorts/woofz_smd/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('nove8/cohorts/woofz_smd/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzSmd,
      })),
    ),
  },
  [Cohort.WOOFZ_SMD_BL]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_SMD_BL,
          }),
      })),
    ),
    Header: lazy(() =>
      import('nove8/cohorts/woofz_smd_bl/components/header/Header').then(
        (m) => ({
          default: m.Header,
        }),
      ),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('nove8/cohorts/woofz_smd_bl/BgPreloadingMediaProvider').then(
        (m) => ({
          default: m.BgPreloadingMediaProviderWoofzSmdBl,
        }),
      ),
    ),
  },
  [Cohort.WOOFZ22_V4_BG]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ22_V4_BG,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz22_v4_bg/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz22_v4_bg/BgPreloadingMediaProvider').then(
        (m) => ({
          default: m.BgPreloadingMediaProviderWoofz22V4Bg,
        }),
      ),
    ),
  },
  [Cohort.WOOFZ22_V4_WT]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ22_V4_WT,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz22_v4_wt/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz22_v4_wt/BgPreloadingMediaProvider').then(
        (m) => ({
          default: m.BgPreloadingMediaProviderWoofz22V4Wt,
        }),
      ),
    ),
  },
  [Cohort.WOOFZ_PT1_BG]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_PT1_BG,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_pt1_bg/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_pt1_bg/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderWoofzPt1Bg,
      })),
    ),
  },
  [Cohort.WOOFZ_K9_BL_BG]: {
    RoutesList: lazy(() =>
      import('nove8/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_WOOFZ_K9_BL_BG,
          }),
      })),
    ),
    Header: lazy(() =>
      import('../cohorts/woofz_k9_bl_bg/components/header/Header').then(
        (m) => ({
          default: m.Header,
        }),
      ),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('../cohorts/woofz_k9_bl_bg/BgPreloadingMediaProvider').then(
        (m) => ({
          default: m.BgPreloadingMediaProviderWoofzK9BlBg,
        }),
      ),
    ),
  },
}
